import { render, staticRenderFns } from "./FormulasTable.vue?vue&type=template&id=ae645f88&"
import script from "./FormulasTable.vue?vue&type=script&lang=ts&"
export * from "./FormulasTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports